const customChannelWGSL = /* wgsl */`
fn customChannelMap(t: f32, colormap: u32) -> vec3f {
    if (colormap == 1u) {
        let c0 = vec3f(0.2777273, 0.0054073, 0.3340998);
        let c1 = vec3f(0.1050930, 1.4046135, 1.3845902);
        let c2 = vec3f(-0.3308618, 0.2148476, 0.0950952);
        let c3 = vec3f(-4.6342305, -5.7991010, -19.3324409);
        let c4 = vec3f(6.2282699, 14.1799334, 56.6905526);
        let c5 = vec3f(4.7763850, -13.7451454, -65.3530326);
        let c6 = vec3f(-5.4354559, 4.6458526, 26.3124352);
        return c0 + t * (c1 + t * (c2 + t * (c3 + t * (c4 + t * (c5 + t * c6)))));
    }
    if (colormap == 2u) {
        let red = vec4f(0.1357214, 4.6153926, -42.6603226, 132.1310823);
        let green = vec4f(0.0914026, 2.1941884, 4.8429666, -14.1850333);
        let blue = vec4f(0.1066733, 12.6419461, -60.5820484, 110.3627677);
        let red2 = vec2f(-152.9423940, 59.2863794);
        let green2 = vec2f(4.2772986, 2.8295660);
        let blue2 = vec2f(-89.9031091, 27.3482497);
        let v4 = vec4f(1.0, t, t * t, t * t * t);
        let v2 = v4.zw * v4.z;
        return vec3f(dot(v4, red) + dot(v2, red2), dot(v4, green) + dot(v2, green2), dot(v4, blue) + dot(v2, blue2));
    }
    return vec3f(t);
}
`;

export { customChannelWGSL };
